import React from 'react';
import { CircularProgress } from '@mui/material';
import { SVGS, TouchableOpacity } from '@zonofi/seller-hub';
import { ReactComponent as ArrowLeft } from '@zonofi/svg-icons/arrow_left.svg';
import { CurrentWorkspaceCard } from './current-workspace-card';
import { Workspace } from '@zonofi/zono-money-store';

export interface WorkspaceSwitcherProps {
  workspace: Workspace;
  workspacesList: Workspace[];
  /** Id of the workspace currently being loaded (shows spinner). */
  workspaceId: string;
  onBackPress: () => void;
  onWorkspacePress: (workspace: Workspace) => void;
}

export const WorkspaceSwitcher: React.FC<WorkspaceSwitcherProps> = ({
  workspace,
  workspacesList,
  workspaceId,
  onBackPress,
  onWorkspacePress,
}) => {
  return (
    <div className="side-drawer-root">
      <div className="side-drawer-root--workspace-header">
        <TouchableOpacity onPress={onBackPress}>
          <ArrowLeft color="#ffffff" width={20} height={20} />
        </TouchableOpacity>
        <span className="side-drawer-header--text font-semibold">
          Workspaces
        </span>
      </div>

      <div className="side-drawer-divider" />

      <span className="side-drawer-header--subtext-v2 font-regular">
        Selected Workspace
      </span>
      <div className="side-drawer-header">
        <CurrentWorkspaceCard workspace={workspace} isCurrent={false} />
        <img
          src={SVGS.Checked}
          width={20}
          height={20}
          className="side-drawer-header--check"
          alt="selected"
        />
      </div>

      <div className="side-drawer-divider" />

      <span className="side-drawer-header--subtext-v2 font-regular">
        Other Workspaces
      </span>

      {workspacesList?.map((ws) => {
        const isLoading = workspaceId === ws.id;
        return (
          <div
            key={ws.id}
            className="side-drawer-list-item"
            style={{ position: 'relative', opacity: isLoading ? 0.6 : 1 }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.background = 'rgba(255,255,255,0.1)')
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.background = 'transparent')
            }
            onClick={() => !isLoading && onWorkspacePress(ws)}
          >
            <CurrentWorkspaceCard workspace={ws} isCurrent={false} />
            {isLoading && (
              <div className="side-drawer-loader">
                <CircularProgress size={20} color="inherit" />
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};
